import React, { memo } from 'react';
import { injectIntl } from 'react-intl';
import { makeStyles } from '@mui/styles';
import { Card, CardContent, CardHeader, Divider, Grid, Typography, Tooltip } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

const useStyles = makeStyles(theme => ({
  scoreBadge: {
    textAlign: 'center',
    borderRadius: 4,
    padding: theme.spacing(1),
    minWidth: 72
  },
  scoreLabel: {
    fontSize: 10,
    fontWeight: 700,
    lineHeight: 1.2
  },
  scoreValue: {
    fontSize: 22,
    fontWeight: 700
  },
  swatch: {
    width: 16,
    height: 16,
    borderRadius: 3
  },
  headerCell: {
    fontWeight: 700
  },
  totalRow: {
    fontWeight: 700
  }
}));

// Painel genérico de pizza/tabela de classificação (usado por csat-table e nps-table).
const ScorePanel = memo(function ScorePanel(props) {
  const classes = useStyles();
  const { id, title, resultLabel, scoreLabel, scoreValue, scoreColor, rows, icon, tooltip, intl, accentColor } = props;

  const total = rows.reduce((sum, row) => sum + (row.value || 0), 0);
  const getPercent = value => (total > 0 ? ((value / total) * 100).toFixed(0) : 0);

  return (
    <Card id={id} style={{ height: '100%' }}>
      <CardHeader
        avatar={icon && <span className="mexx-dyn-color" style={{ '--mexx-dyn-color': accentColor || 'var(--mexx-green-primary)', display: 'flex' }}>{icon}</span>}
        title={
          tooltip ? (
            <Tooltip title={tooltip}><span>{title}</span></Tooltip>
          ) : title
        }
        action={
          <div className={`${classes.scoreBadge} mexx-dyn-bg`} style={{ '--mexx-dyn-bg': scoreColor }}>
            <Typography className={classes.scoreLabel}>{scoreLabel}</Typography>
            <Typography className={classes.scoreValue}>{scoreValue}</Typography>
          </div>
        }
      />
      <Divider />
      <CardContent>
        <Typography variant="body2" gutterBottom>{resultLabel}</Typography>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell className={classes.headerCell}>{intl.formatMessage({ id: 'agentproductivity.dashboard.score.legend', defaultMessage: 'Legenda' })}</TableCell>
                <TableCell className={classes.headerCell}>{intl.formatMessage({ id: 'agentproductivity.dashboard.score.status', defaultMessage: 'Situação' })}</TableCell>
                <TableCell className={classes.headerCell} align="right">{intl.formatMessage({ id: 'agentproductivity.dashboard.score.percent', defaultMessage: 'Percentual' })}</TableCell>
                <TableCell className={classes.headerCell} align="right">{intl.formatMessage({ id: 'agentproductivity.dashboard.score.amount', defaultMessage: 'Quantidade' })}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, index) => (
                <TableRow key={`score-row-${index}`}>
                  <TableCell>
                    <Grid container alignItems="center">
                      <div className={`${classes.swatch} mexx-dyn-bg`} style={{ '--mexx-dyn-bg': row.color }} />
                    </Grid>
                  </TableCell>
                  <TableCell>{row.label}</TableCell>
                  <TableCell align="right">{getPercent(row.value)}%</TableCell>
                  <TableCell align="right">{row.value}</TableCell>
                </TableRow>
              ))}
              <TableRow className={classes.totalRow}>
                <TableCell colSpan={2}>{intl.formatMessage({ id: 'agentproductivity.dashboard.score.total', defaultMessage: 'Total' })}</TableCell>
                <TableCell align="right">100%</TableCell>
                <TableCell align="right">{total}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
});

export default injectIntl(ScorePanel);
